import logger from '@/modules/Logger';

export default {
  // check the connection used in rtc (STUN/TURN Server)
  // values info: https://developer.mozilla.org/en-US/docs/Web/API/RTCIceCandidateType
  checkIceCandidates() {
    try {
      if (this.rtc._highStream) {
        const peerConnection = this.rtc._highStream.pc.pc;
        let candidate = {};

        peerConnection.onicecandidate = (evt) => {
          if (evt.candidate) {
            candidate = evt.candidate
          }
        }

        peerConnection.onicegatheringstatechange = () => {
          if (peerConnection.iceGatheringState === 'complete') {
            this.rtcServer = this.getRTCServer(candidate);
            logger.info('[Agora] RTC ICE Server: ' + this.rtcServer, { operation: 'webrtc:ice-server' });
          }
        }
      }
    } catch (error) {
      logger.error('Error on gathering ICE server', { operation: 'webrtc:ice-server', reason: error.message,event_type:48,lesson_id:this.lessonId });
    }
  }
}

